import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import "./index.scss";

const PrivacyDataProtectionModal = (props) => {
  const handleClose = () => props.setShow(false);
  const handleShow = () => props.setShow(true);

  return (
    <>
      <Modal
        show={props.show}
        onHide={handleClose}
        size="lg"
        className="privacy-data-protection"
      >
        <Modal.Body className="p-4">
          <h6>GİZLİLİK VE VERİ KORUMA POLİTİKASI</h6>
          <p>
            Türkiye’de kurulu, PİNAPS REKLAM ORGANİZASYON VE KONGRE
            HİZ.TİC.LTD.ŞTİ, LEVENT MAH. ÜST ZEREN SOK. NO:2 BEŞİKTAŞ/İSTANBUL
            adresinde mukim, 0730036903500001 mersis no’lu Beşiktaş Vergi
            Dairesi, 730 036 9035 no’lu vergi mükellefi, PİNAPS REKLAM
            ORGANİZASYON VE KONGRE HİZ.TİC.LTD.ŞTİ (“Pinaps”) olarak; veri
            sorumlusu sıfatıyla, ticari ilişkilerimiz kapsamında veya sizlerle
            olan iş ilişkimiz dahilinde, kişisel verilerinizin, işlenmelerini
            gerektiren amaç çerçevesinde ve bu amaç ile bağlantılı, sınırlı ve
            ölçülü şekilde, tarafımıza bildirdiğiniz veya bildirildiği şekliyle
            kişisel verilerin doğruluğunu ve en güncel halini koruyarak,
            kaydedileceğini, depolanacağını, muhafaza edileceğini, yeniden
            düzenleneceğini, kanunen bu kişisel verileri talep etmeye yetkili
            olan kurumlar ile paylaşılacağını, yurtiçi veya yurtdışı üçüncü
            kişilere aktarılacağını, devredileceğini, sınıflandırılabileceğini
            ve Kişisel Verileri Koruma Kanunu’nda (Bundan sonra “KVKK” olarak
            anılacaktır) sayılan sair şekillerde işlenebileceğini bildiririz;
            <br />
            <br />
            Aşağıda belirttiğimiz ve tarafımıza sağladığınız kişisel
            verilerinizin her koşulda; duruma göre aşağıda belirtilen şekillerde
            elde ettiğimiz kişisel verilerinizin hukuki ilişkilerimiz
            kapsamında, <br />
            <br />
            İşlenmelerini gerektiren amaç çerçevesinde ve bu amaçla bağlantılı,
            sınırlı ve ölçülü şekilde, <br />
            <br />
            Tarafımıza bildirdiğiniz veya bildirildiği şekliyle kişisel
            verilerin doğruluğunu ve en güncel halini koruyarak,
            <br />
            <br />
            Kaydedileceğini, depolanacağını, muhafaza edileceğini, yeniden
            düzenleneceğini, kanunen bu kişisel verileri talep etmeye yetkili
            olan kurumlar ile paylaşılacağını ve KVKK’nın öngördüğü şartlarda,
            yurtiçinde üçüncü kişilere aktarılacağını, devredileceğini,
            sınıflandırılabileceğini ve KVKK’da sayılan sair şekillerde
            işlenebileceğini bildiririz.
          </p>
          <h6>KİŞİSEL VERİLERİNİZİ HANGİ AMAÇLARLA İŞLİYORUZ?</h6>
          <p>
            Anayasa, İş Kanunu, İş Sağlığı ve Güvenliği Kanunu, İş Sağlığı ve
            Güvenliği Hizmetleri Yönetmeliği, Türk Borçlar Kanunu, Türk Medeni
            Kanunu ve diğer ilgili mevzuatlar çerçevesinde ve Career Plus
            etkinliğine yaptığınız başvuru çerçevesinde etkinliğe katılım için
            yetkinlik değerlendirmesi süreçlerine ilişkin meşru menfaat gibi
            hukuki sebeplere dayanılarak; etkinlik alanının düzenlenmesi,
            katılımcıların belirlenmesi, katılımcı kitlesinin analizi, daha
            sonraki etkinlikler için fikir oluşturması ya da katılımcı
            listelerinin oluşturulması çalışmaları amacıyla fotoğraf ve
            görüntülerinizin işlenmesine ilişkin süreçlerin yürütülmesi gibi
            amaçlarla Pinaps, özel nitelikli kişisel verileriniz de dahil olmak
            üzere, yukarıda belirtilen çerçevede elde edilen kişisel
            verileriniz, yalnızca KVKK’nın 5. ve 6. maddelerinde belirtilen
            kişisel veri işleme şartları çerçevesinde işlenebilir.
          </p>
          <h6>HAKLARINIZ</h6>
          <p>
            Veri sahibi, işlenen Kişisel Verileri’nin neler olduğunu ve işlenip
            işlenmediğini, işleme amacı doğrultusunda kullanılıp
            kullanılmadığını öğrenebilir, verileri işlenmişse bu hususta bilgi
            talep edebilir, yurt içi veya yurt dışında Kişisel Veriler’in
            aktarıldığı üçüncü kişileri öğrenebilir, eksik veya yanlış işlenen
            Kişisel Veriler söz konusu ise veya işlenen Kişisel Verileri’nde
            herhangi bir değişiklik olması durumunda bu verilerin
            düzeltilmesini, değiştirilmesini, güncellenmesini, KVKK’nın 7.
            maddesinde öngörülen şartlar çerçevesinde silinmesini/yok edilmesini
            veya anonim hale getirilmesini, bu işlemlerin (eksik veya yanlış
            işlenen Kişisel Verileri söz konusu ise, bu verilerin düzeltilmesini
            veya KVKK’nın 7. maddesinde öngörülen şartlar çerçevesinde
            silinmesini/yok edilmesini veya anonim hale getirilmesini) Kişisel
            Veriler’in aktarıldığı üçüncü kişilere bildirilmesini talep
            edebilir; işlenen verilerin münhasıran otomatik sistemler ile analiz
            edilmesi nedeniyle aleyhine bir sonucun ortaya çıkmasına itiraz
            edebilir ve Kişisel Veriler’in kanuna aykırı olarak işlenmesi
            sebebiyle zarara uğraması hâlinde zararın giderilmesini talep
            edebilir. Kullanıcı/Üye, bu kapsamdaki haklarını KVKK md. 11
            uyarınca: <br />
            <br />
            Pinaps’ın hakkınızda kişisel veri işleyip işlemediğini öğrenmek,
            eğer işlemişse, buna ilişkin bilgi talep etmek, <br />
            <br />
            Kişisel verilerinizin işlenme amacını ve bunların amacına uygun
            kullanılıp kullanılmadığı öğrenmek, <br />
            <br />
            Kişisel verilerin yurtiçi veya yurtdışına aktarılıp aktarılmadığı ve
            kimlere aktarıldığını öğrenmek haklarına sahipsiniz. <br />
            <br />
            Ayrıca, Pinaps’tan yanlış ve eksik kişisel verilerinizin
            düzeltilmesini ve verilerinin aktarıldığı veya aktarılmış
            olabileceği alıcıların bilgilendirilmesini talep etme hakkınız
            vardır. <br />
            <br />
            Kişisel verilerinizin KVKK madde 7’de öngörülen şartlar çerçevesinde
            verilerinizin imha edilmesini (silinmesini, yok edilmesini veya
            anonim hale getirilmesini) Pinaps’tan talep edebilirsiniz. Aynı
            zamanda verilerin aktarıldığı veya aktarılabileceği 3. kişilerin söz
            konusu imha talebiniz ile ilgili bilgilendirilmesini talep
            edebilirsiniz. Ancak imha talebinizi değerlendirerek hangi yöntemin
            uygun olduğu somut olayın koşullarına göre tarafımızca
            değerlendirilecektir. Bu bağlamda seçtiğimiz imha yöntemini neden
            seçtiğimiz ile ilgili bizden her zaman bilgi talep edebilirsiniz.{" "}
            <br />
            <br />
            Münhasıran bir otomatik sistem kullanılarak oluşturulmuş kişisel
            veri analizinizin sonuçlarına bu sonuçlar çıkarlarınıza aykırıysa
            itiraz edebilirsiniz. <br />
            <br />
            Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle
            zarara uğramanız halinde zararın giderilmesini talep edebilirsiniz.
            <br />
            <br />
            Başvurunuzda yer alan talepleriniz, talebin niteliğine göre en geç
            otuz gün içinde ücretsiz olarak sonuçlandırılacaktır. Ancak, işlemin
            Pinaps için ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel
            Verileri Koruma Kurulu tarafından Veri Sorumlusuna Başvuru Usul ve
            Esasları Hakkında Tebliğ’de belirlenen tarifedeki ücret alınabilir.{" "}
            <br />
            <br />
            Kişisel verilerinizin işlenmesi ile ilgili hususlarda başvurunuzu,
            bu Aydınlatma Metni’nin ekinde yer alan başvuru formunu doldurarak,
            yazılı olarak veya kayıtlı elektronik posta (KEP) adresi, güvenli
            elektronik imza, mobil imza ya da bize daha önce bildirdiğiniz ve
            kayıtlarımızda yer alan elektronik posta adresinizi kullanmak
            suretiyle Pinaps’a teslim etmeniz gerekmektedir. Pinaps tarafından
            talebinizin mahiyetine ve başvuru yönteminize göre Pinaps tarafından
            başvurunun size ait olup olmadığının belirlenmesi ve böylece
            haklarınızı koruyabilmek amacıyla ek doğrulamalar (kayıtlı
            telefonunuza mesaj gönderilmesi, aranmanız gibi) istenebilir.
            Örneğin Pinaps’ta kayıtlı olan e-posta adresiniz aracılığıyla
            başvuru yapmanız halinde Pinaps’ta kayıtlı başka bir iletişim
            yöntemini kullanarak size ulaşabilir ve başvurunun size ait olup
            olmadığının teyidini isteyebiliriz.
          </p>
          <h6>KİŞİSEL VERİ SAKLAMA SÜRESİ</h6>
          <p>
            Şirketimiz, KVKK uyarınca işlediği Kişisel Verileri yalnızca ilgili
            mevzuatta öngörülen veya mevzuatta bir süre öngörülmemiş ise kişisel
            veri işleme amacının gerektirdiği süre kadar muhafaza eder. Tutulan
            veriler verinin işlenmesini gerektiren sebepler sona erdikten sonra
            silinir, yok edilir veya anonim hale getirilir. Örnek vermek
            gerekirse 6563 Sayılı Elektronik Ticaretin Düzenlenmesi Hakkında
            Kanun ile buna bağlı yönetmelik uyarınca Kişisel Veriler’in
            pazarlama veya tanıtım amaçları için kullanılacağına ilişkin veri
            sahibinin onayının geri alındığı durumlarda, Kişisel Veriler’in
            kayıtları bu tarihten itibaren 1 yıl saklanır. Ticari elektronik
            iletinin içeriği ve gönderiye ilişkin diğer her türlü kayıt ise
            gerektiğinde ilgili bakanlığa sunulmak üzere 3 yıl saklanır. 5651
            Sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi ve Bu
            Yayınlar Yoluyla İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun
            uyarınca ise işlediğimiz trafik verileri 2 yıl saklanır ve süre
            bittikten sonra anonim hale getirilir. Her halükârda Kişisel
            Veriler’in birden fazla sebeple işlenmiş olması halinde, söz konusu
            verinin işlenmesini gerektiren tüm nedenler ortadan kalktığında
            ilgili veri silinir, yokedilir veya anonim hale getirilir.
          </p>
          <h6>KİŞİSEL VERİLERİNİZİN KORUNMASINA İLİŞKİN ÖNLEMLER </h6>
          <p>
            Kişisel Veriler’in korunması Şirketimiz için önemli bir konudur.
            Kişisel Veriler’e yetkisiz erişim veya bu bilgilerin kaybı, hatalı
            kullanımı, ifşa edilmesi, değiştirilmesi veya imha edilmesine karşı
            veri sahibini korumak için gerekli teknik ve idari her türlü önlemi
            almaktayız. Kişisel Veriler’i işlerken genel kabul görmüş güvenlik
            teknolojisi standartlarını kullanmaktayız. <br />
            <br />
            Kişisel Veriler’i gizli tutmayı, gizliliğin sağlanması ve güvenliği
            için gerekli teknik ve idari her türlü tedbiri almayı ve gerekli
            özeni göstermeyi taahhüt etmekteyiz. Gerekli bilgi güvenliği
            önlemlerini almamıza karşın, Şirketimiz’e ait internet sitesine ve
            sisteme yapılan saldırılar sonucunda Kişisel Veriler’in zarar
            görmesi veya üçüncü kişilerin eline geçmesi durumunda, bu durumu
            derhal sizlere ve Kişisel Verileri Koruma Kurulu’na bildirir ve
            gerekli önlemleri alırız.
          </p>
          <h6>UYGULANACAK HUKUK, YETKİLİ MAHKEME VE İCRA DAİRELERİ </h6>
          <p>
            İşbu Gizlilik, Kişisel Verilerin Korunması ve Çerez Politikası,
            Türkiye Cumhuriyeti kanunlarına tabidir. Gizlilik, Kişisel Verilerin
            Korunması ve Çerez Politikası’nın uygulanmasından doğabilecek her
            türlü uyuşmazlığın çözümünde İstanbul Çağlayan Mahkeme ve İcra
            Daireleri yetkilidir.
          </p>
          <h6>İLETİŞİM İZNİ</h6>
          <p>
            Veri sahibinin Şirketimiz ile paylaşmış olduğu Kişisel Veriler;
            hizmetlerimizin içerik ve tanıtımlarımızın geliştirilmesi ve
            kişileştirilmesi veya yeni hizmetler sunabilmek amacıyla ve her
            türlü iletişim mesajlarının gönderilmesi amacıyla Şirketimizce
            kullanabilir. Bu veriler, aynı zamanda sadece sözleşme ilişkisi
            içinde olduğumuz, veri güvenliği konusundaki hassasiyetimizi
            paylaşan, ilgili mevzuat hükümlerine riayet eden 3. kişilerle,
            yalnızca ihtiyaç durumunda ve gerekli ölçüde paylaşılacaktır. Veri
            sahibi, bu tanıtımları almamak veya söz konusu
            reklam-kişiselleştirme, yeniden hedefleme uygulamalarında yer almak
            istemediği takdirde, taleplerini her zaman internet sitesinde yer
            alan iletişim bilgilerinden Şirketimiz’e ulaşarak da iletebilir.
          </p>
        </Modal.Body>
        <Modal.Footer className="py-1">
          <Button size="sm" variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default PrivacyDataProtectionModal;
